module.exports = __webpack_public_path__ + "static/media/customer-care.6b66240a.svg";